export const columnOrder = [
    'name',
    'battery',
    'solar',
    'load',
    'grid',
    'paygo',
    'generator',
    'serviceTime',
    'runningSince',
    'fuel',
    'temperature',
    'lastUpdate',
    'dateAdded',
    'alarm',
];

export const columnsWithEnergy = {
    solar: 'solar_yield',
    load: 'consumption',
    grid: 'from_to_grid',
    generator: 'generator',
};

export const batterySortOptions = {
    SOC: 'bs',
    VOLTAGE: 'bv',
};

export const sortOrders = {
    ASCENDING: 'ascending',
    DESCENDING: 'descending',
};

export const batteryDropdownOptions = [
    {
        id: 0,
        column: 'battery',
        value: batterySortOptions.SOC,
        order: sortOrders.DESCENDING,
        label: 'installationoverview.descending_soc_battery',
        i18nFallback: 'Descending battery SOC',
    },
    {
        id: 1,
        column: 'battery',
        value: batterySortOptions.SOC,
        order: sortOrders.ASCENDING,
        label: 'installationoverview.ascending_soc_battery',
        i18nFallback: 'Ascending battery SOC',
    },
    {
        id: 2,
        column: 'battery',
        value: batterySortOptions.VOLTAGE,
        order: sortOrders.DESCENDING,
        label: 'installationoverview.descending_battery_voltage',
        i18nFallback: 'Descending battery voltage',
    },
    {
        id: 3,
        column: 'battery',
        value: batterySortOptions.VOLTAGE,
        order: sortOrders.ASCENDING,
        label: 'installationoverview.ascending_battery_voltage',
        i18nFallback: 'Ascending battery voltage',
    },
];

export const tankSortOptions = {
    FUEL: 'tank,0',
    WATER: 'tank,1,3',
    SEWAGE: 'tank,2,5',
    OIL: 'tank,4',
};

export const tankDropdownOptions = [
    {
        id: 0,
        column: 'fuel',
        value: tankSortOptions.FUEL,
        order: sortOrders.DESCENDING,
        label: 'installationoverview.descending_fuel_tank',
        i18nFallback: 'Descending fuel level',
    },
    {
        id: 1,
        column: 'fuel',
        value: tankSortOptions.FUEL,
        order: sortOrders.ASCENDING,
        label: 'installationoverview.ascending_fuel_tank',
        i18nFallback: 'Ascending fuel level',
    },
    {
        id: 2,
        column: 'fuel',
        value: tankSortOptions.OIL,
        order: sortOrders.DESCENDING,
        label: 'installationoverview.descending_oil_tank',
        i18nFallback: 'Descending oil level',
    },
    {
        id: 3,
        column: 'fuel',
        value: tankSortOptions.OIL,
        order: sortOrders.ASCENDING,
        label: 'installationoverview.ascending_oil_tank',
        i18nFallback: 'Ascending oil level',
    },
    {
        id: 4,
        column: 'fuel',
        value: tankSortOptions.SEWAGE,
        order: sortOrders.DESCENDING,
        label: 'installationoverview.descending_sewage_tank',
        i18nFallback: 'Descending sewage level',
    },
    {
        id: 5,
        column: 'fuel',
        value: tankSortOptions.SEWAGE,
        order: sortOrders.ASCENDING,
        label: 'installationoverview.ascending_sewage_tank',
        i18nFallback: 'Ascending sewage level',
    },
    {
        id: 6,
        column: 'fuel',
        value: tankSortOptions.WATER,
        order: sortOrders.DESCENDING,
        label: 'installationoverview.descending_water_tank',
        i18nFallback: 'Descending water level',
    },
    {
        id: 7,
        column: 'fuel',
        value: tankSortOptions.WATER,
        order: sortOrders.ASCENDING,
        label: 'installationoverview.ascending_water_tank',
        i18nFallback: 'Ascending water level',
    },
];

export const lowFuelThreshold = 0;

export const temperatureSortOptions = {
    BATTERY: 'temperature,0',
    FRIDGE: 'temperature,1',
    GENERIC: 'temperature,2',
};

export const temperatureDropdownOptions = [
    {
        id: 0,
        column: 'temperature',
        value: temperatureSortOptions.BATTERY,
        order: sortOrders.DESCENDING,
        label: 'installationoverview.descending_battery_temperature',
        i18nFallback: 'Descending Battery Temperature',
    },
    {
        id: 1,
        column: 'temperature',
        value: temperatureSortOptions.BATTERY,
        order: sortOrders.ASCENDING,
        label: 'installationoverview.ascending_battery_temperature',
        i18nFallback: 'Ascending Battery Temperature',
    },
    {
        id: 2,
        column: 'temperature',
        value: temperatureSortOptions.FRIDGE,
        order: sortOrders.DESCENDING,
        label: 'installationoverview.descending_fridge_temperature',
        i18nFallback: 'Descending Fridge Temperature',
    },
    {
        id: 3,
        column: 'temperature',
        value: temperatureSortOptions.FRIDGE,
        order: sortOrders.ASCENDING,
        label: 'installationoverview.ascending_fridge_temperature',
        i18nFallback: 'Ascending Fridge Temperature',
    },
    {
        id: 4,
        column: 'temperature',
        value: temperatureSortOptions.GENERIC,
        order: sortOrders.DESCENDING,
        label: 'installationoverview.descending_generic_temperature',
        i18nFallback: 'Descending Generic Temperature',
    },
    {
        id: 5,
        column: 'temperature',
        value: temperatureSortOptions.GENERIC,
        order: sortOrders.ASCENDING,
        label: 'installationoverview.ascending_generic_temperature',
        i18nFallback: 'Ascending Generic Temperature',
    },
];
